/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BooleanResponse } from "../models/BooleanResponse";
import type { Response_str_ } from "../models/Response_str_";
import type { Response_StripeCheckoutSession_ } from "../models/Response_StripeCheckoutSession_";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class BillingService {
  /**
   * Provision Free Trial
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static billingProvisionFreeTrial(): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/billing/free-trial",
    });
  }
  /**
   * Get Checkout Session
   * @param sessionId
   * @returns Response_StripeCheckoutSession_ Successful Response
   * @throws ApiError
   */
  public static billingGetCheckoutSession(
    sessionId: string
  ): CancelablePromise<Response_StripeCheckoutSession_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/billing/checkout-session",
      query: {
        session_id: sessionId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Checkout Session
   * @returns Response_str_ Successful Response
   * @throws ApiError
   */
  public static billingCreateCheckoutSession(): CancelablePromise<Response_str_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/billing/checkout",
    });
  }
  /**
   * Create Billing Portal Session
   * @param organizationId
   * @returns Response_str_ Successful Response
   * @throws ApiError
   */
  public static billingCreateBillingPortalSession(
    organizationId: string
  ): CancelablePromise<Response_str_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/billing/{organization_id}/portal",
      path: {
        organization_id: organizationId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
